import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { getUserFromLocalStorage } from '../../utils/userHelper';
import profileImage from '../profile/images/profilePic3.webp';

const ProfileDropdown = ({ onProfile, onLogout }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const user = getUserFromLocalStorage();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative w-10 h-10" ref={dropdownRef}>
      {/* Avatar Button */}
      <button
        onClick={() => setOpen((prev) => !prev)}
        className="w-10 h-10 rounded-full overflow-hidden border border-gray-300 hover:ring-2 hover:ring-orange-400 transition"
      >
        <img
          src={user?.profilePic?.url || profileImage}
          alt="Profile"
          className="w-full h-full object-cover"
        />
      </button>

      {/* Dropdown */}
      {open && (
        <div className="absolute right-0 mt-3 w-52 rounded-xl bg-white shadow-xl border border-gray-200 backdrop-blur-sm animate-dropdown">
          <div className="py-2">
            <DropdownItem
              label="Profile"
              icon={UserIcon}
              onClick={() => {
                setOpen(false);
                onProfile?.();
              }}
            />

            <div className="my-1 border-t border-gray-200" />

            <DropdownItem
              label="Logout"
              icon={LogoutIcon}
              danger
              onClick={() => {
                setOpen(false);
                onLogout?.();
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileDropdown;

ProfileDropdown.propTypes = {
  onProfile: PropTypes.func,
  onLogout: PropTypes.func,
};

const DropdownItem = ({ label, icon: Icon, onClick, danger = false }) => {
  return (
    <button
      onClick={onClick}
      className={`w-full flex items-center gap-3 px-4 py-2 text-sm font-medium
        ${
          danger
            ? 'text-red-600 hover:bg-red-50'
            : 'text-gray-700 hover:bg-gray-100'
        }
        transition`}
    >
      <Icon className="w-5 h-5" />
      {label}
    </button>
  );
};

DropdownItem.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.func,
  onClick: PropTypes.func,
  danger: PropTypes.bool,
};

const UserIcon = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
  >
    <path d="M12 12a5 5 0 100-10 5 5 0 000 10z" />
    <path d="M20 21a8 8 0 10-16 0" />
  </svg>
);

UserIcon.propTypes = {
  className: PropTypes.string,
};

const LogoutIcon = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
  >
    <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
    <path d="M16 17l5-5-5-5" />
    <path d="M21 12H9" />
  </svg>
);

LogoutIcon.propTypes = {
  className: PropTypes.string,
};
